export interface ITransitionEvent {
	type: "enter" | "enter-complete" | "leave" | "leave-complete"; // NOTE: compared to Vue, the states for hooks are purely trigger based
	element: HTMLElement;
}
